import { render, staticRenderFns } from "./HubInformation.vue?vue&type=template&id=52c8e540&scoped=true&"
import script from "./HubInformation.vue?vue&type=script&lang=js&"
export * from "./HubInformation.vue?vue&type=script&lang=js&"
import style0 from "./HubInformation.vue?vue&type=style&index=0&id=52c8e540&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c8e540",
  null
  
)

export default component.exports